// 为你推荐 type=4

import mixin from './mixin'

export default {
  mixins: [mixin],

  render () {
    const {
      list, // from mixin
      style, // from mixin
      onClick, // from mixin
      title // from mixin
    } = this
    console.log('list', this)
    return (
      <section class={style.block}>
        <h2 class={style.title}>{title}</h2>
        {
          list.map(item => (
            <img
              class={style.img1}
              src={item.imageUrl}
              alt={item.number}
              onClick={() => onClick(item)}
            />
          ))
        }
      </section>
    )
  }
}
